export const homeworkConstants = {
  GET_HOMEWORK: "GET_HOMEWORK",
  GET_HOMEWORK_SUCCESS: "GET_HOMEWORK_SUCCESS",
  SAVE_STUDENT_ANSWER: "SAVE_STUDENT_ANSWER",
  GET_RANKINGS: "GET_RANKINGS",
  GET_RANKINGS_SUCCESS: "GET_RANKINGS_SUCCESS",
};
